import {
    DEALERWITHDRAWEMONEYLIST_SUCCESS,
    DEALERWITHDRAWEMONEYLIST_FAILED,
    RESET_DEALERWITHDRAWEMONEYLIST,
    LOADING_DEALERWITHDRAWEMONEYLIST,
    NETWORK_ERROR_DEALERWITHDRAWEMONEYLIST
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerWithdrawEMoneyList = () => {
    return { type: RESET_DEALERWITHDRAWEMONEYLIST };
};

const dealerWithdrawEMoneyList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERWITHDRAWEMONEYLIST });
    await dealerServices
        .post("getWithDrawEMoneyList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerWithdrawEMoneyListsuccess(res.data));
                    break;
                default:
                    dispatch(dealerWithdrawEMoneyListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERWITHDRAWEMONEYLIST,
                payload: err
            });
        });
};
function dealerWithdrawEMoneyListsuccess(data) {
    return {
        type: DEALERWITHDRAWEMONEYLIST_SUCCESS,
        payload: data
    };
}
function dealerWithdrawEMoneyListFailed(data) {
    return {
        type: DEALERWITHDRAWEMONEYLIST_FAILED,
        payload: data
    };
}

export { resetDealerWithdrawEMoneyList, dealerWithdrawEMoneyList };
